module.exports = __webpack_public_path__ + "media/images/logo/niet_gebruikt/medmij-1101afbdbcedb248b971a20fd43b4a6a.svg";